import { HttpInterceptorFn } from '@angular/common/http';

export const contentTypeInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.body instanceof FormData || req.body instanceof Blob || req.body instanceof File) {
    return next(req);
  } else {
    const clonedReq = req.clone({
      headers: req.headers.set('Content-Type', 'application/json'),
    });
    return next(clonedReq);
  }
};


